import moment from 'moment-es6'
import {
  RESET_RESOURCE_MODULE,
  SET_RESOURCES_END_DATE,
  SET_RESOURCES_LIST,
  SET_RESOURCES_START_DATE,
  SET_RESOURCE_WEIGHTING,
  SET_STUDENT_RESOURCE_HISTORY,
  SET_STUDENT_RESOURCE_HISTORY_LOADING,
  SET_STUDENT_RESOURCE_HISTORY_LOADED,
  APPEND_STUDENT_RESOURCE_HISTORY,
  SOFT_RESET_RESOURCE_HISTORY,
  SOFT_RESET_STUDENT_RESOURCE
} from '../mutation-types'
import {
  GET_STUDENT_RESOURCES, GET_STUDENT_RESOURCE_WEIGHTINGS,
  GET_STUDENT_RESOURCE_HISTORY, GET_STUDENT_RESOURCE_HISTORY_NEXT, LOGOUT } from '../action-types'
import * as axios from 'axios'

const state = () => ({
  resources: [],
  weighting: [],
  history: [],
  loadingHistory: false,
  allHistoryLoaded: false,
  historyCurrentPage: -1,
  historyPageSize: 50,
  dateRange: {
    startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    endDate: moment().subtract(1, 'd').format('YYYY-MM-DD')
  },
  resourceIconMap: {
    DEFAULT: 'book',
    TURNITIN: 'file_upload',
    LIBRARY: 'library_books',
    ELOGIN: 'vpn_key',
    VLELOGIN: 'vpn_key',
    DROPBOX: 'cloud_upload'
  },
  functions: {
    resource: 'STURESTAB'
  },
  options: {
    enable: {
      resourceWeighting: 'ENBRESWGT'
    }
  }
})

function processHistoryDates (history, lastDate = '01/01/1000') {
  return history.map(item => {
    let date = moment(item.resourceUsageDate).format('DD/MM/YYYY')
    let changed = date !== lastDate
    lastDate = date
    return {
      id: item.id,
      resourceUsageDate: date,
      resourceIdentifier: item.resourceIdentifier,
      resourceCount: item.resourceCount,
      dateChanged: changed
    }
  })
}

function loadHistory (rootState, state, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/resource_usage/filter`,
    method: 'post',
    data: {
      studentId,
      fromDate: state.dateRange.startDate,
      toDate: state.dateRange.endDate,
      pageNumber: state.historyCurrentPage + 1,
      pageSize: state.historyPageSize,
      ascDesc: 'DESC',
      sortBy: 'RESOURCE_USAGE_DATE'
    },
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

const mutations = {
  [SET_RESOURCES_START_DATE] (state, startDate) {
    state.dateRange.startDate = startDate
  },
  [SET_RESOURCES_END_DATE] (state, endDate) {
    state.dateRange.endDate = endDate
  },
  [SET_RESOURCES_LIST] (state, list) {
    state.resources = list
  },
  [SET_RESOURCE_WEIGHTING] (state, weighting) {
    state.weighting = weighting
  },
  [SET_STUDENT_RESOURCE_HISTORY] (state, history) {
    state.history = history
  },
  [SET_STUDENT_RESOURCE_HISTORY_LOADING] (state) {
    state.loadingHistory = true
  },
  [SET_STUDENT_RESOURCE_HISTORY_LOADED] (state, loadState) {
    state.loadingHistory = false
    state.historyCurrentPage++
    state.allHistoryLoaded = loadState.allHistoryLoaded
  },
  [APPEND_STUDENT_RESOURCE_HISTORY] (state, history) {
    history.forEach(item => {
      state.history.push(item)
    })
  },
  [SOFT_RESET_RESOURCE_HISTORY] (state) {
    state.history = []
    state.loadingHistory = false
    state.allHistoryLoaded = false
    state.historyCurrentPage = -1
  },
  [RESET_RESOURCE_MODULE] (s) {
    const initial = state()
    Object.keys(initial).forEach(key => { s[key] = initial[key] })
  },
  [SOFT_RESET_STUDENT_RESOURCE] (state) {
    state.resources = []
  }
}

const actions = {
  [GET_STUDENT_RESOURCES] ({rootState, state, commit}, id) {
    const actionData = { action: GET_STUDENT_RESOURCES, data: id }
    commit(SOFT_RESET_STUDENT_RESOURCE)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${id}/get/resource_usage_detail/${state.dateRange.startDate}/${state.dateRange.endDate}`,
      method: 'get',
      data: {},
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        commit(SET_RESOURCES_LIST, res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [GET_STUDENT_RESOURCE_WEIGHTINGS] ({rootState, state, commit}, id) {
    const actionData = { action: GET_STUDENT_RESOURCE_WEIGHTINGS, data: id }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/resource/weightings/${id}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    })
      .then((res) => {
        let data = res.data.weightings.sort((a, b) => b.weight - a.weight)
        commit(SET_RESOURCE_WEIGHTING, data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [GET_STUDENT_RESOURCE_HISTORY] ({commit, rootState, state}, studentId) {
    commit(SOFT_RESET_RESOURCE_HISTORY)
    commit(SET_STUDENT_RESOURCE_HISTORY_LOADING)
    const actionData = { action: GET_STUDENT_RESOURCE_HISTORY, data: studentId }
    loadHistory(rootState, state, studentId, actionData)
      .then((res) => {
        commit(SET_STUDENT_RESOURCE_HISTORY, processHistoryDates(res.data.content))
        commit(SET_STUDENT_RESOURCE_HISTORY_LOADED, {
          allHistoryLoaded: res.data.last
        })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [GET_STUDENT_RESOURCE_HISTORY_NEXT] ({commit, rootState, state}, studentId) {
    commit(SET_STUDENT_RESOURCE_HISTORY_LOADING)
    const actionData = { action: GET_STUDENT_RESOURCE_HISTORY_NEXT, data: studentId }
    loadHistory(rootState, state, studentId, actionData)
      .then((res) => {
        let previousDate = (state.history.length > 0) ? state.history[state.history.length - 1].resourceUsageDate : '01/01/1000'
        commit(APPEND_STUDENT_RESOURCE_HISTORY, processHistoryDates(res.data.content, previousDate))
        commit(SET_STUDENT_RESOURCE_HISTORY_LOADED, {
          allHistoryLoaded: res.data.last
        })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [LOGOUT] ({commit}) {
    commit(RESET_RESOURCE_MODULE)
  }
}

const getters = {}

export default {
  state: state(),
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/resources.js